import { Attribute, useConfigurator } from 'views/ProductPage/configurators/useConfigurator';
import { NumericInput } from 'views/ProductPage/configurators/numericInput';
import { Validate } from 'views/ProductPage/configurators/rules';

interface Props extends Attribute {
  validate: Validate;
}

export const AttributeNumeric = ({ validate, ...a }: Props) => {
  const { onSelectChange } = useConfigurator();
  const onBlur = (input: string) => {
    if (!input || validate(a.id, input)) {
      return;
    }
    const number = parseFloat(input);
    const variant = a.values
      .map(({ value }) => parseFloat(value))
      .filter(v => !isNaN(v))
      .sort((a, b) => a - b)
      .find(value => number <= value);
    variant && onSelectChange(a.id, variant.toString(), { emit: false });
  };
  return <NumericInput {...a} onBlur={onBlur} />;
};
